// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanContributionDto
 */
export interface IPlanContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanContributionDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanContributionDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanContributionDto
     */
    account_type?: IPlanContributionDtoAccountTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPlanContributionDto
     */
    coverage_period_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanContributionDto
     */
    coverage_period_end?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanContributionDto
     */
    is_plan_disabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPlanContributionDto
     */
    per_pay_employee?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanContributionDto
     */
    per_pay_employer?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPlanContributionDto
     */
    claim_submit_date_end?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPlanContributionDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IPlanContributionDto interface.
 */
export function instanceOfIPlanContributionDto(value: object): value is IPlanContributionDto {
    return true;
}

export function IPlanContributionDtoFromJSON(json: any): IPlanContributionDto {
    return IPlanContributionDtoFromJSONTyped(json, false);
}

export function IPlanContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'coverage_period_start': json['coverage_period_start'] == null ? undefined : (new Date(json['coverage_period_start'])),
        'coverage_period_end': json['coverage_period_end'] == null ? undefined : (new Date(json['coverage_period_end'])),
        'is_plan_disabled': json['is_plan_disabled'] == null ? undefined : json['is_plan_disabled'],
        'per_pay_employee': json['per_pay_employee'] == null ? undefined : json['per_pay_employee'],
        'per_pay_employer': json['per_pay_employer'] == null ? undefined : json['per_pay_employer'],
        'claim_submit_date_end': json['claim_submit_date_end'] == null ? undefined : (new Date(json['claim_submit_date_end'])),
    };
}

export function IPlanContributionDtoToJSON(json: any): IPlanContributionDto {
    return IPlanContributionDtoToJSONTyped(json, false);
}

export function IPlanContributionDtoToJSONTyped(value?: IPlanContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_code': value['plan_code'],
        'account_type': value['account_type'],
        'coverage_period_start': value['coverage_period_start'] == null ? undefined : ((value['coverage_period_start']).toISOString().substring(0,10)),
        'coverage_period_end': value['coverage_period_end'] == null ? undefined : ((value['coverage_period_end']).toISOString().substring(0,10)),
        'is_plan_disabled': value['is_plan_disabled'],
        'per_pay_employee': value['per_pay_employee'],
        'per_pay_employer': value['per_pay_employer'],
        'claim_submit_date_end': value['claim_submit_date_end'] == null ? undefined : ((value['claim_submit_date_end']).toISOString().substring(0,10)),
    };
}

